import Vue from 'vue'
import Vuex from 'vuex'
import collections from './modules/collections'
import apiKeys from './modules/apiKeys'
import objects from './modules/objects'
import nodes from './modules/nodes'
import accounts from './modules/accounts'
import projects from './modules/projects'
import schemas from './modules/schemas'
import authentication from './modules/authentication'
import augmentations from './modules/augmentations'
import createLogger from '../plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
	modules: {
		nodes,
		accounts,
		projects,
		collections,
		apiKeys,
		objects,
		schemas,
		augmentations,
		authentication
	},
	strict: debug,
	plugins: debug ? [createLogger()] : []
});

// store.watch(
// 	(state, getters) => getters['nodes/currentNodeId']( ), (newValue, oldValue) =>
// 	{
// 		console.log( "RESETTING PROJECTS: Current Node changed from ["+ oldValue +"] to ["+ newValue +"]" );
// 		store.commit( 'projects/setProjects', [] );
// 	}
// );

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js